import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import StoreSearchFilterItemContainer from './StoreSearchFilterItem/StoreSearchFilterItemContainer.js';

var StoreSearchFilters = (_param)=>{
    var { className , filters , setFilterActivity  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "filters",
        "setFilterActivity"
    ]);
    const visibleFilters = filters.filter(([, value])=>{
        if (value.hidden === true) {
            return false;
        }
        return true;
    });
    if (!visibleFilters.length) {
        return null;
    }
    return /*#__PURE__*/ React.createElement("ul", swcHelpers.extends({}, rest, {
        className: classnames('store-search-filters', className)
    }), visibleFilters.map(([filterKey, filter])=>/*#__PURE__*/ React.createElement("li", {
            key: filterKey.toString(),
            className: "store-search-filters__list-item"
        }, /*#__PURE__*/ React.createElement(StoreSearchFilterItemContainer, {
            filterKey: filterKey.toString(),
            filter: filter,
            setFilterActivity: setFilterActivity
        }))
    ));
};
var StoreSearchFilters$1 = StoreSearchFilters;

export { StoreSearchFilters, StoreSearchFilters$1 as default };
//# sourceMappingURL=StoreSearchFilters.js.map
